class ConsolidatedTransaction {
  customerId: number;
  customerDigit: number;
  customerSurname: string;
  system: number;
  accountNumber: string;
  accountCode: number;
  currencyId: number;
  currencyShortDescription: string;
  routeGenericDetailDescription: string;
  routeGenericDetailShortDescription: string;
  routeGenericDetailParameterType: string;
  routeGenericDetailSerialNum: number;
  orderId: number;
  orderCode: string;
  orderTrxDate: string;
  orderDirection: string;
  orderAmount: number;
  orderMessageType: string;
  beneficiaryName: string;
  beneficiaryAccount: string;
  beneficiaryIsoCountry: string;
  beneficiaryBic: string;
  beneficiarySortCode: string;
  orderComments: string;
  externalIdRef: string;
  processType: string;
  correspondingAccount: string;
  correspondingCustomerId: number;
  trxUser: string;
  trxUnit: number;
  timestamp: string;
  orderLogicalKey: string;
  financialDate: string;
  routingResultDescription: string;
  orderValueDate: string;
  processingStatus: number;
  systemDate: string;
  transferDate: string;
  transactionNo: string;
  beneficiaryBank: string;
  disabled: boolean;
  status: number;

  constructor(
    customerId: number,
    customerDigit: number,
    customerSurname: string,
    system: number,
    accountNumber: string,
    accountCode: number,
    currencyId: number,
    currencyShortDescription: string,
    routeGenericDetailDescription: string,
    routeGenericDetailShortDescription: string,
    routeGenericDetailParameterType: string,
    routeGenericDetailSerialNum: number,
    orderId: number,
    orderCode: string,
    orderTrxDate: string,
    orderDirection: string,
    orderAmount: number,
    orderMessageType: string,
    beneficiaryName: string,
    beneficiaryAccount: string,
    beneficiaryIsoCountry: string,
    beneficiaryBic: string,
    beneficiarySortCode: string,
    orderComments: string,
    externalIdRef: string,
    processType: string,
    correspondingAccount: string,
    correspondingCustomerId: number,
    trxUser: string,
    trxUnit: number,
    timestamp: string,
    orderLogicalKey: string,
    financialDate: string,
    routingResultDescription: string,
    orderValueDate: string,
    processingStatus: number,
    systemDate: string,
    transferDate: string,
    beneficiaryBank: string,
    status: number,
  ) {
    this.customerId = customerId;
    this.customerDigit = customerDigit;
    this.customerSurname = customerSurname;
    this.system = system;
    this.accountNumber = accountNumber;
    this.accountCode = accountCode;
    this.currencyId = currencyId;
    this.currencyShortDescription = currencyShortDescription;
    this.routeGenericDetailDescription = routeGenericDetailDescription;
    this.routeGenericDetailShortDescription = routeGenericDetailShortDescription;
    this.routeGenericDetailParameterType = routeGenericDetailParameterType;
    this.routeGenericDetailSerialNum = routeGenericDetailSerialNum;
    this.orderId = orderId;
    this.orderCode = orderCode;
    this.orderTrxDate = orderTrxDate;
    this.orderDirection = orderDirection;
    this.orderAmount = orderAmount;
    this.orderMessageType = orderMessageType;
    this.beneficiaryName = beneficiaryName;
    this.beneficiaryAccount = beneficiaryAccount;
    this.beneficiaryIsoCountry = beneficiaryIsoCountry;
    this.beneficiaryBic = beneficiaryBic;
    this.beneficiarySortCode = beneficiarySortCode;
    this.orderComments = orderComments;
    this.externalIdRef = externalIdRef;
    this.processType = processType;
    this.correspondingAccount = correspondingAccount;
    this.correspondingCustomerId = correspondingCustomerId;
    this.trxUser = trxUser;
    this.trxUnit = trxUnit;
    this.timestamp = timestamp;
    this.orderLogicalKey = orderLogicalKey;
    this.financialDate = financialDate;
    this.routingResultDescription = routingResultDescription;
    this.orderValueDate = orderValueDate;
    this.processingStatus = processingStatus;
    this.systemDate = systemDate;
    this.transferDate = transferDate;
    //TODO: Revise once middleware provides solution
    this.transactionNo = orderId.toString();
    this.beneficiaryBank = beneficiaryBank;
    this.disabled = !Boolean(this.orderId);
    this.status = status;
  }
}

export { ConsolidatedTransaction };
